export default function capitalize(str: string): string {
  const firstLetter = str.charAt(0).toUpperCase();
  const restOfKey = str.slice(1);

  return `${firstLetter}${restOfKey}`;
}
